// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"1a4c49e2","455":"3ed6b4f9","977":"f11ee999"}[chunkId] + ".chunk.js";
};